import { useCart, useCartLine } from "@shopify/hydrogen";

export function useLineItem() {
    const {linesRemove} = useCart();
    const {id: lineId, quantity, merchandise} = useCartLine()

    return {
        models: {
            lineId,
            quantity,
            merchandise,
        },
        operations: {
            linesRemove
        }
    }
}
